import Projects from '../../DAL/Projects'
import Sites from '../../DAL/Sites'
import {makeSiteAddress, assembleProject} from '.'
import { setDoc } from 'firebase/firestore'

export default async function projectModify(project, fields) {

  //console.log('is it equal to project',project) // old persisted by now 

  const projRef = new Projects().docRef(project.id)
  const siteRef = new Sites().docRef(project.site.id)

  try {
    const {latitude, longitude} = fields
    const {siteAddress = ``, dummyAddress = ``, sameAddress = false} = fields
    const {siteOwnerName = ``, sameRep = false, siteRepName = ``, siteRepEmail = ``, siteRepPhone = ``} = fields
    const {client = {id: ``, name: ``, qualifications: {}}, inspector, inspectorType = null, installer, formRubrics} = fields
    const {projectType, rubric, organization} = fields
    const {restrict_schedule} = fields

    let site = {
      siteOwnerName,
      sameRep,
      siteRepName,
      siteRepEmail,
      siteRepPhone,
      id: siteRef.id,
      siteAddress,
      sameAddress,
    }

    site = await makeSiteAddress({project, site, dummyAddress, siteAddress, latitude, longitude})
    await setDoc(siteRef, site)

    //console.log('and now ??',project) // old presisted ??

    await assembleProject({
      client,
      installer,
      inspector,
      inspectorType,
      rubric,
      organization,
      site,
      project,
      projRef,
      projectType,
      restrict_schedule,
      formRubrics
    })
  } catch (e) {
    console.log(`an error occurred while updating a project: `, e)
    throw e
  }
}
